module.exports = __webpack_public_path__ + "static/media/bike parcel service in hyderabad.2810a078.jpg";